{
  "version": 1,
  "asset_id": "6275095c-0f5a-4c8f-abd4-5e6d8bfcb124",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6275095c-0f5a-4c8f-abd4-5e6d8bfcb124/sleeve-to-bypass-completed-es-640.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6275095c-0f5a-4c8f-abd4-5e6d8bfcb124/sleeve-to-bypass-completed-es-640.webp",
  "original_filename": "sleeve-to-bypass-completed-es-640.webp",
  "size": 32934,
  "content_type": "image/webp",
  "created_at": "2026-10-05T12:46:49Z"
}
